let queryId = 0;

export function makeQueryId(tag: string) {
  return `query-id-${queryId++}${tag ? `-${tag}` : ''}`;
}
